import React, { useState } from "react";
import { bool } from "prop-types";
import { routerActions } from "connected-react-router";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";

import CustomButton from "pages/_components/CustomButton/CustomButton";
import { TransactionCard, TransactionHeader } from "pages/_components/TransactionCard";
import Button from "pages/_components/Button";
import useReactPrint from "pages/_components/Print/useReactToPrint";
import { MobileButtons, ResponsiveHeader } from "pages/_components/header";
import Action from "pages/_components/Action";
import AgreementSummary from "./components/AgreementSummary";
import { useAgreementTransaction } from "./hooks/useAgreementTransaction";

const SuccessTransactionPage = ({ isDesktop }) => {
    const { isLoading, transaction, dispatch, id, isBackoffice } = useAgreementTransaction();
    const { componentRef, handlePrint, mobileRef, handleShareMobile } = useReactPrint(
        "account.agreement.request",
        id,
        "/accounts/agreements/successTransaction/",
    );
    const [showMoreData, setShowMoreData] = useState(!isDesktop);
    const handleDownload = async () => {
        await setShowMoreData(true);
        return handlePrint();
    };

    return (
        <>
            <Notification scopeToShow="/accounts/agreements/successTransaction/" />
            {!isBackoffice && (
                <ResponsiveHeader ticket metaTitle="account.agreement.request">
                    <>
                        <MobileButtons>
                            <Action labelKey="global.download" handleClick={handleDownload} />
                            <Action labelKey="global.share" handleClick={handleShareMobile} />
                        </MobileButtons>
                    </>
                </ResponsiveHeader>
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container" ref={componentRef}>
                    <div ref={mobileRef}>
                        <TransactionCard transaction={transaction}>
                            <TransactionHeader title="account.agreement.request" />
                            <div className="ticket">
                                <div className="ticket__wrapper">
                                    <div className="ticket__header" />
                                    <AgreementSummary
                                        title="account.agreement.request"
                                        isTicket
                                        isDesktop={isDesktop}
                                        setShowMoreData={setShowMoreData}
                                        showMoreData={showMoreData}
                                    />
                                    <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                                </div>
                            </div>
                        </TransactionCard>
                    </div>
                    {!isBackoffice && (
                        <Row className="form-actions no-print">
                            <Col xs={12} md={4} mdOffset={2}>
                                <CustomButton
                                    func={() => dispatch(routerActions.push("/desktop"))}
                                    text="forms.transaction.ticket.actions.backToHome"
                                    textType="I18N"
                                    className="btn btn-outline"
                                />
                            </Col>
                            {isDesktop && (
                                <Col xs={12} md={4}>
                                    <Button
                                        className="btn btn-primary"
                                        image="images/figma/icon/download.svg"
                                        label="global.download"
                                        onClick={handleDownload}
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </>
    );
};

SuccessTransactionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default SuccessTransactionPage;
